export default __webpack_public_path__ + "static/media/Indu-cropped.97997e9c.jpeg";